/**
 * Đếm ký tự và số tin của một mẫu SMS.
 *
 * BẢN SAO của phonenet-common/helpers/SmsTemplateCounter.js — phonenet-admin không
 * phụ thuộc phonenet-common nên không dùng chung được. Sửa một bên phải sửa mọi bên:
 * phonenet-common, callio-client/src/utils và file này. Ba màn phải ra cùng một con số,
 * nếu không khách soạn thấy một đằng, admin duyệt thấy một nẻo.
 *
 * Cú pháp tham số trong nội dung: {ten_bien,so_ky_tu} — ví dụ {name,30}.
 * Số ký tự tính theo TRƯỜNG HỢP XẤU NHẤT: mỗi tham số coi như dài hết mức đã khai,
 * vì lúc gửi thật nhà mạng chốt số tin theo nội dung sau khi thay tham số.
 */

const STEPS_UNICODE = [70, 134, 201, 268, 335, 402, 469, 536, 603];
const STEPS_PLAIN = [160, 306, 459, 612, 765, 918, 1071, 1224, 1377];
const MAX_SMS = 9;

/**
 * Đọc các tham số {ten,so} có trong nội dung.
 * @returns [{key: '{name,30}', value: '30'}] — key giữ cả dấu ngoặc, đúng như dữ liệu đang lưu.
 */
export function getParams(content) {
  if (!content) return [];
  let result = [];
  let buffer = '';
  for (const char of String(content)) {
    if (char === '{') {
      buffer = '{';
      continue;
    }
    if (!buffer) continue;
    if (char !== '}') {
      buffer += char;
      continue;
    }
    buffer += char;
    const parts = buffer.slice(1, -1).split(',');
    // Bỏ qua thứ trông giống tham số nhưng không phải: thiếu vế, vế sau không phải số.
    if (parts.length === 2 && parts[0].trim() && parts[1].trim() && !isNaN(Number(parts[1].trim()))) {
      result.push({key: buffer, value: parts[1].trim()});
    }
    buffer = '';
  }
  return result;
}

/** Nội dung có ký tự ngoài bảng mã không dấu thì nhà mạng tính theo bậc có dấu. */
export function isUnicodeContent(content) {
  return /[^ -~\r\n\t]/.test(String(content || ''));
}

export function countSms(content, unicode) {
  const text = String(content || '');
  const params = getParams(text);
  const unicodeFlag = typeof unicode === 'boolean' ? unicode : isUnicodeContent(text);

  let characterCount = text.length;
  for (const param of params) {
    characterCount += Number(param.value) - param.key.length;
  }
  if (characterCount < 0) characterCount = 0;

  const steps = unicodeFlag ? STEPS_UNICODE : STEPS_PLAIN;
  const limit = steps[steps.length - 1];
  let numberOfSms = steps.findIndex(step => characterCount <= step) + 1;
  if (!numberOfSms) numberOfSms = MAX_SMS + 1;

  return {
    characterCount,
    rawLength: text.length,
    numberOfSms,
    isUnicode: unicodeFlag,
    limit,
    params,
    overLimit: characterCount > limit,
    overMaxSms: numberOfSms > MAX_SMS,
  };
}

export default {countSms, getParams, isUnicodeContent, MAX_SMS};
